import React, {ReactNode, useState} from 'react'
import poweredByNgage from "../../assets/powered-by-ngage.svg";
import Logo from "../../components/Logo";
import {useOperator} from "../../context/OperatorContext";
import {PlatformInBrowser} from "../../components/svg/PlatformInBrowser";
import {Transition} from "@headlessui/react";

// Types ----

type AuthPageWrapperProps = {
  children: ReactNode
}

// Component ----

function AuthPageWrapper({children}: AuthPageWrapperProps) {
  const {operator} = useOperator();

  const [showPlatformInBrowser, setShowPlatformInBrowser] = useState(false);

  const operatorLogo = operator?.settings.branding.logo;

  return (
    <div className='h-full grid grid-cols-1 md:grid-cols-[1fr_minmax(300px,_480px)] overflow-x-hidden'>
      <img src={poweredByNgage} className='absolute top-2.5 left-4 z-10' alt="Powered by n-gage.io" />

      {/* Left column */}
      <div className='relative flex flex-col items-center justify-center pt-20 px-5 pb-4 md:pl-10 md:pr-4'>
        <div className='w-full flex flex-col flex-1 items-center justify-center'>
          {children}
        </div>

        {/* Legal text */}
        <div className='flex flex-wrap gap-x-6 gap-y-2 justify-center text-xs text-gray-500 w-full text-center px-4 pt-10'>
          <p className=''>{`© ${(new Date()).getFullYear()} Fame Media Tech Limited. n-gage.io is a registered trademark.`}</p>

          <div className='flex flex-wrap gap-x-4 gap-y-2 justify-center'>
            <a href="https://www.n-gage.io/terms-of-use-operator-platform" className='hover:text-gray-800'>Privacy Policy</a>
            <a href="https://www.n-gage.io/authorised-user-privacy-notice" className='hover:text-gray-800'>Terms of Use</a>
          </div>
        </div>
      </div>

      {/* Right column */}
      <div className='hidden md:flex flex-col overflow-hidden relative'>
        <Transition
          show={showPlatformInBrowser}
          enter="transition-all duration-[2000ms]"
          enterFrom="opacity-0 translate-x-5"
          enterTo="opacity-100 translate-x-0"
          unmount={false}
        >
          <div className='absolute top-20'>
            <PlatformInBrowser />

            <div className='w-[238px] h-[106px] flex justify-center items-center absolute top-[44px] left-[40px]'>
              <div className="max-w-40">
                <Logo src={operatorLogo?.original_url} size={Logo.sizes.X_LARGE} onLoad={() => {
                  setShowPlatformInBrowser(true)}
                } />
              </div>
            </div>
          </div>
        </Transition>
      </div>
    </div>
  );
}

export {AuthPageWrapper};